import { render } from "./OverviewGroup.vue?vue&type=template&id=f8640f90"
import script from "./OverviewGroup.vue?vue&type=script&lang=js"
export * from "./OverviewGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__